<template>
  <div>
    <div v-columns="{ columns: 1, breakpoints: { 780: 2 } }" class="audience columns-list">
      <div class="panel" style="min-height: 350px" v-if="canShowCountries">
        <div class="aud-header">
          <h2>{{ $t('DASHBOARD_AUDIENCE_CHARTS_COUNTRIES') }}</h2>
        </div>
        <div class="countries">
          <div
            class="one-country"
            :key="index"
            v-for="(country, index) in topCountries"
          >
            <div class="m-chart">
              <div
                class="chart"
                :ref="`country${index}`"
              ></div>
            </div>

            <span class="country-code" :title="country.name">{{
              country.name
            }}</span>
          </div>
        </div>
      </div>
      <div class="panel" v-if="canShowAges">
        <div class="aud-header">
          <h2>{{ $t('DASHBOARD_AUDIENCE_CHARTS_AGES') }}</h2>
          <div class="settings">
            <button
              @click="setByAgeSelector(type.value)"
              :class="isActiveByAgeClass(type.value)"
              :key="index"
              v-for="(type, index) in typesList"
            >
              {{ type.label }}
            </button>
          </div>
        </div>
        <div class="cont" v-if="page.social == 'VK'">
          <div class="metrics-list">
            <div>to 18</div>
            <div>18-21</div>
            <div>21-24</div>
            <div>24-27</div>
            <div>27-30</div>
            <div>30-35</div>
            <div>35-45</div>
            <div>45+</div>
          </div>
          <div class="m-chart">
            <div
              class="chart"
              :ref="`ages`"
            ></div>
          </div>
        </div>
        <div class="cont" v-if="page.social != 'VK'">
          <div class="metrics-list">
            <div>13-17</div>
            <div>18-24</div>
            <div>25-34</div>
            <div>35-44</div>
            <div>45-54</div>
            <div>55-64</div>
            <div>65+</div>
          </div>
          <div class="m-chart">
            <div
              class="chart"
              :ref="`ages`"
            ></div>
          </div>
        </div>
      </div>

      <div class="panel heatmap" v-if="canShowOnline">
        <div class="aud-header">
          <h2>{{ $t('DASHBOARD_AUDIENCE_CHARTS_ONLINE') }}</h2>
        </div>
        <div class="m-chart">
          <div class="chart" :ref="`online`"></div>
          <div class="heat-legend" :ref="`online-legend`" :data-color-code="page.colorCode"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pageCharts from "@/models/page-charts";
import RadarOne from "@/models/charts/eradar-countries";
import gorizontalColumns from "@/models/charts/egorizontal-columns";
import HeatMap from "@/models/charts/eheatMap";
import i18n from '@/i18nSetup';

const countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

import columnsDirective from "@/directives/columnsDirective.js";
import { scheduleCharts } from "@/models/charts/echarts-touch";

export default {
  name: "Dash-audience-one",
  components: {},
  directives: {
    columns: columnsDirective
  },  
  computed: {
    ...mapGetters([
      "getAnalizedPages",
      "getUnionPagesData",
      "getAnalizedAdminPages",
    ]),
    page() {
      return this.getAnalizedPages[0];
    },
    locale() {
      return this.$locale.DASHBOARD.AUDIENCE_CHARTS;
    },
    canShowCountries() {
      return !!(this.page.is_admin && this.page.audienceStats.countries);
    },
    canShowAges() {
      return !!(
        this.page.is_admin &&
        (this.page.audienceStats.sex_age ||
          this.page.audienceStats.page_fans_gender_age)
      );
    },
    canShowOnline() {
      return !!(this.page.is_admin && this.page.audienceStats.online_followers);
    },
    topCountries() {
      const pages = this.getAnalizedAdminPages.filter(
        (page) => page.audienceStats && page.audienceStats.countries
      );
      if (pages.length === 0) return [];
      
      const data = pageCharts.countries(pages).map((d) => {
        if (d.code == "RU") return { ...d, name: "Russia" };
        if (d.code == "US") return { ...d, name: "USA" };
        if (d.code == "A1") return { ...d, name: "Anonymous" };
        if (d.code == "EU") return { ...d, name: "EU" };

        const name = countries.getName(d.code, "en");
        if (name.length > 10) return { ...d, name: name.slice(0, 10) + "..." };
        return { ...d, name };
      });
      return data;
    },
  },
  data() {
    return {
      loaded: true,
      byCountrySelector: "All",
      byAgeSelector: "All",
      typesList: [
        { value: "All", label: i18n.t('AUDIENCE_ALL') },
        { value: "Men", label: i18n.t('AUDIENCE_MEN') },
        { value: "Women", label: i18n.t('AUDIENCE_WOMEN') },
      ],
      rendered: false,
      loaded: false
    };
  },
  methods: {
    isActiveByCountryClass(type) {
      if (this.byCountrySelector == type) return "active";
      return "";
    },
    setByCountrySelector(type) {
      this.byCountrySelector = type;
    },
    isActiveByAgeClass(typeValue) {
      return this.byAgeSelector === typeValue ? "active" : "";
    },
    setByAgeSelector(typeValue) {
      this.byAgeSelector = typeValue;
      this._ageGen = (this._ageGen || 0) + 1;
      setTimeout(this.renderAgesChart, 0);
    },
    formatCountryName(name) {},
    renderRadarCountriesCharts(jobs, renderId) {
      const pages = this.getAnalizedAdminPages;

      const calculateTotal = this.topCountries.reduce((acc, val) => {
        pages.forEach((_, i) => {
          acc[`count_${i}`]
            ? (acc[`count_${i}`] += val[`count_${i}`])
            : (acc[`count_${i}`] = val[`count_${i}`]);
        });
        return acc;
      }, {});

      const circleColors = [
        "#4979E2",
        "#8C49E2",
        "#F39930",
        "#09ADB8",
        "#ff2e94",
        // "#F84E4EL",
        "#FFEC43",
        "#1FDC76",
        "#CDF335",
        "#60D9FF",
        "#1DABD8",
        // "#60D9FF",
        // "#B4ECFE",
        "#779501",
        // "#97BA0A",
        // "#B6DB22",
        "#C8EF2C",
        // "#F84E4E",
        // "#F98F8F",
        "#FAC2C2",
      ];

      this.topCountries.forEach((country, index) => {
        const ref = this.$refs[`country${index}`];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (!el) return;
        jobs.push({
          el,
          run: async () => {
            const chart = await RadarOne({
              ref,
              maxValue: calculateTotal,
              color: circleColors[index],
              country,
              pages,
            });
            if (this._renderId !== renderId) {
              if (chart && chart.chart && chart.chart.dispose) chart.chart.dispose();
              return;
            }
            this.charts.countries[index] = chart;
          },
        });
      });
    },

    async renderAgesChart() {
      const { pages, datesRangePosts } = this.getUnionPagesData;
      const page = pages[0];
      const data = pageCharts.ages(pages, this.byAgeSelector);
      if (this.charts.ages) {
        this.charts.ages.dispose();
        this.charts.ages = null;
      }
      this.charts.ages = await gorizontalColumns({
        ref: this.$refs.ages,
        data,
        pages,
      });
    },
    renderOnlineChart() {
      if (this.page.social != "VK" && this.$refs.online && this.$refs["online-legend"]) {
        return HeatMap({
          ref: Array.isArray(this.$refs.online) ? this.$refs.online[0] : this.$refs.online,
          page: this.page,
          refLegend: Array.isArray(this.$refs["online-legend"]) ? this.$refs["online-legend"][0] : this.$refs["online-legend"],
        });
      }
      return null;
    },

    renderCharts() {
      const renderId = (this._renderId = (this._renderId || 0) + 1);
      if (this._stopCharts) this._stopCharts();
      if (this.charts.ages && this.charts.ages.dispose) {
        this.charts.ages.dispose();
        this.charts.ages = null;
      }
      this.charts.countries = [];
      const jobs = [];
      if (this.canShowCountries) this.renderRadarCountriesCharts(jobs, renderId);
      if (this.canShowAges) {
        const agesRef = this.$refs.ages;
        const el = Array.isArray(agesRef) ? agesRef[0] : agesRef;
        if (el) {
          jobs.push({
            el,
            run: async () => {
              const gen = this._ageGen || 0;
              const { pages } = this.getUnionPagesData;
              const chart = await gorizontalColumns({
                ref: agesRef,
                data: pageCharts.ages(pages, this.byAgeSelector),
                pages,
              });
              if (this._renderId !== renderId || (this._ageGen || 0) !== gen) return;
              this.charts.ages = chart;
            },
          });
        }
      }
      if (this.canShowOnline && this.page.social != "VK" && this.$refs.online && this.$refs["online-legend"]) {
        const onlineRef = this.$refs.online;
        const el = Array.isArray(onlineRef) ? onlineRef[0] : onlineRef;
        jobs.push({
          el,
          run: async () => {
            const chart = await HeatMap({
              ref: el,
              page: this.page,
              refLegend: Array.isArray(this.$refs["online-legend"]) ? this.$refs["online-legend"][0] : this.$refs["online-legend"],
            });
            if (this._renderId !== renderId && chart && chart.dispose) chart.dispose();
          },
        });
      }
      this._stopCharts = scheduleCharts(jobs, { batchSize: 3 });
    }

  },
  created() {
    this.charts = {
      countries: [],
      ages: null,
      online: [],
    };
  },
  mounted() {
    setTimeout(this.renderCharts, 0);
  },
  updated() {},
  beforeDestroy() {
    this._renderId = (this._renderId || 0) + 1;
    if (this._stopCharts) this._stopCharts();
    if (this.charts.ages && this.charts.ages.dispose) {
      this.charts.ages.dispose();
      this.charts.ages = null;
    }
    this.charts.countries.forEach((result) => {
      if (result && result.chart && typeof result.chart.dispose === "function") {
        result.chart.dispose();
      }
    });
  },
};
</script>

<style></style>
